import * as tslib_1 from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let LineCount = class LineCount extends Vue {
};
LineCount = tslib_1.__decorate([
    Component({})
], LineCount);
export default LineCount;
